// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--954ee";